__webpack_require__.p = "https://njb.design/";